import { Directive, ElementRef, EventEmitter, HostListener, Output, inject } from '@angular/core';

@Directive({
  selector: '[outsideClickHost]',
  standalone: false,
})
export class OutsideClickDirective {
  private elementRef = inject(ElementRef<HTMLElement>);

  @Output() outsideClick = new EventEmitter<PointerEvent>();

  @HostListener('document:pointerdown', ['$event'])
  onDocumentPointerDown(event: PointerEvent) {
    const isInsideHost = event.composedPath().includes(this.elementRef.nativeElement);

    if (!isInsideHost) {
      this.outsideClick.emit(event);
    }
  }
}
